// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2IQHi","text":"SelectPayment_text__6EoMP","title":"SelectPayment_title__1hjkh","btn":"SelectPayment_btn__3UM1V"};